import { Alert, Form, InputNumber } from 'antd';
import { FormInstance } from 'antd/lib/form';
import useBackupRetention from '../../core/hooks/useBackupRetention';
import AppLoading from '../AppLoading';
import styles from '../ccx/common/AppForm.module.less';
import DeploymentsItem from '../../types/DeploymentsItem';
import { Draft } from '@reduxjs/toolkit';
import usePiwikPro from '../../core/hooks/usePiwikPro';
import {
    CLICK_EVENT,
    DATASTORE_BACKUP_SETTINGS_UPDATED,
} from '../../core/PiwikConstants';

type BackupsSettingsFormProps = {
    form: FormInstance;
    deployment?: Draft<DeploymentsItem>;
    onSuccess?: () => void;
};

export default function BackupsSettingsForm({
    form,
    deployment,
    onSuccess,
}: BackupsSettingsFormProps) {
    const { trackEvent } = usePiwikPro();
    const { retention, loading, update, error } = useBackupRetention(
        deployment?.dataStoreUuid
    );

    const handleSubmit = async (values: any) => {
        await update(values.retention);
        trackEvent(CLICK_EVENT, DATASTORE_BACKUP_SETTINGS_UPDATED);
        onSuccess?.();
    };

    return loading ? (
        <AppLoading />
    ) : (
        <Form
            form={form}
            layout="vertical"
            initialValues={{
                retention,
            }}
            onFinish={handleSubmit}
        >
            <Form.Item
                name="retention"
                label="Retention period"
                rules={[
                    {
                        required: true,
                        message: 'Please input retention period',
                    },
                ]}
            >
                <InputNumber
                    placeholder={'Enter retention'}
                    addonAfter={'days'}
                    type="number"
                    min={1}
                    className={styles.AppFormWithAddonInput}
                />
            </Form.Item>

            {error && (
                <Alert type={'error'} message={`Error: ${error.message}`} />
            )}
        </Form>
    );
}
